import { render, staticRenderFns } from "./BatteryLow.vue?vue&type=template&id=d25f7ca6&"
import script from "./BatteryLow.vue?vue&type=script&lang=js&"
export * from "./BatteryLow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports